import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { getSettings, uploadFileInChat } from "../../reducers/commonReducer";
import BannerSlideManager from "./BannerSlideManager";

const schema = yup.object().shape({
  name: yup.string().required(),
  value: yup.string(),
  linkUrl: yup.string(),
  halptext: yup.string().required(),
  status: yup.string().required(),
});
function SettingAction(props) {
  const dispatch = useDispatch();
  const {
    name,
    value,
    halptext,
    status,
    title,
    filter,
    settingKey,
    id,
    api,
    btnTitle,
    lockMeta,
    valueLabel,
    valuePlaceholder,
    valueRows,
    valueType,
    linkUrl,
  } = props;
  const [show, setShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(value || "");
  const [saving, setSaving] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setSelectedImage(null);
    setImagePreview(value || "");
    setShow(true);
  };

  useEffect(() => {
    if (!selectedImage) {
      setImagePreview(value || "");
      return undefined;
    }

    const objectUrl = URL.createObjectURL(selectedImage);
    setImagePreview(objectUrl);

    return () => {
      URL.revokeObjectURL(objectUrl);
    };
  }, [selectedImage, value]);

  const handleImageChange = (event) => {
    setSelectedImage(event.target.files?.[0] || null);
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
      {btnTitle ? btnTitle : <i className="bi bi-pencil-square"></i>}
      </Button>

      <Modal show={show} onHide={handleClose} size={valueType === "slider" ? "lg" : undefined}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Formik
          validationSchema={schema}
          validate={(values) => {
            const formErrors = {};

            if (valueType === "text" && !values.value?.trim()) {
              formErrors.value = "Value is required";
            }

            if (
              valueType === "image" &&
              !selectedImage &&
              !values.value?.trim()
            ) {
              formErrors.value = "Banner image is required";
            }

            return formErrors;
          }}
          onSubmit={async (values) => {
            setSaving(true);
            const payload = { ...values };

            // For slider, value is already JSON set by BannerSlideManager via setFieldValue
            if (valueType === "image" && selectedImage) {
              const uploadResp = await dispatch(
                uploadFileInChat({ fileupload: [selectedImage] })
              );

              if (uploadResp?.payload?.status) {
                payload.value = uploadResp?.payload?.uploads?.[0]?.cloudUrl || "";
              }
            }

            const apiResp = await dispatch(api(payload));
            if (apiResp?.payload?.status) {
              handleClose();
              dispatch(getSettings());
            }
            setSaving(false);
          }}
          initialValues={{
            name,
            value,
            linkUrl: linkUrl || "",
            halptext,
            filter,
            id: id,
            key: settingKey,
            status,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            errors,
            submitCount,
          }) => (
            <Form className="container" onSubmit={handleSubmit}>
              {(lockMeta || valueType === "slider") ? (
                <>
                  <input type="hidden" name="name" value={values.name || ""} />
                  <input type="hidden" name="filter" value={values.filter || ""} />
                  <input type="hidden" name="halptext" value={values.halptext || ""} />
                  <input type="hidden" name="key" value={values.key || ""} />
                </>
              ) : (
                <Row className="mb-3">
                  <Col md={6} sm={12}>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} sm={12}>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>Filter</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Filter"
                        name="filter"
                        value={values.filter}
                        onChange={handleChange}
                        isInvalid={!!errors.filter}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.filter}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              <Row className="mb-3">
                <Col md={(lockMeta || valueType === "slider") ? 12 : 6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>{valueLabel || "Value"}</Form.Label>
                    {valueType === "slider" ? (
                      <BannerSlideManager
                        key={show ? "open" : "closed"}
                        initialValue={value}
                        initialLinkUrl={linkUrl}
                        onChange={(jsonStr) => setFieldValue("value", jsonStr)}
                      />
                    ) : valueType === "image" ? (
                      <>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          isInvalid={!!errors.value}
                        />
                        <Form.Text className="text-muted">
                          Upload a banner image for customers.
                        </Form.Text>
                        {submitCount > 0 && errors.value && (
                          <div className="text-danger mt-2">{errors.value}</div>
                        )}
                        {imagePreview && (
                          <div className="setting-image-preview mt-3">
                            <img src={imagePreview} alt={valueLabel || "banner"} />
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        <Form.Control
                          as="textarea"
                          rows={valueRows || 3}
                          placeholder={valuePlaceholder || "Value"}
                          name="value"
                          value={values.value}
                          onChange={handleChange}
                          isInvalid={!!errors.value}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors.value}
                        </Form.Control.Feedback>
                      </>
                    )}
                  </Form.Group>
                </Col>
                {valueType === "image" && (
                  <Col md={lockMeta ? 12 : 6} sm={12}>
                    <Form.Group controlId="validationFormikLinkUrl">
                      <Form.Label>Banner Link URL</Form.Label>
                      <Form.Control
                        type="url"
                        placeholder="https://example.com"
                        name="linkUrl"
                        value={values.linkUrl}
                        onChange={handleChange}
                        isInvalid={!!errors.linkUrl}
                      />
                      <Form.Text className="text-muted">
                        When customers click this banner, they will open this link.
                      </Form.Text>
                      <Form.Control.Feedback type="invalid">
                        {errors.linkUrl}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                )}
                {!lockMeta && valueType !== "slider" && (
                  <Col md={6} sm={12}>
                    <Form.Group controlId="validationFormik01">
                      <Form.Label>Help Text</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Help Text"
                        name="halptext"
                        value={values.halptext}
                        onChange={handleChange}
                        isInvalid={!!errors.halptext}
                      />

                      <Form.Control.Feedback type="invalid">
                        {errors.halptext}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row className="mb-3">
                {!id && !lockMeta && valueType !== "slider" && <Col md={6} sm={12}>
                  <Form.Group controlId="validationFormik01">
                    <Form.Label>Key</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Key"
                      name="key"
                      value={values.key}
                      onChange={handleChange}
                      isInvalid={!!errors.key}
                    />

                    <Form.Control.Feedback type="invalid">
                      {errors.key}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>}
                <Col md={(lockMeta || valueType === "slider") ? 12 : 6} sm={12}>
                  <Form.Label>Status</Form.Label>
                  <Form.Control
                    as="select"
                    controlId="validationFormik03"
                    onChange={async (e) => {
                      setFieldValue("status", e.target.value);
                    }}
                    name="status"
                    className="form-control"
                    value={values.status}
                    isInvalid={!!errors.status}
                  >
                    <option value="">Select Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>InActive</option>
                  </Form.Control>
                </Col>
              </Row>
              <Modal.Footer>
                <Button variant="success" type="submit" disabled={saving}>
                  {saving ? "Saving..." : "Submit"}
                </Button>
                <Button variant="danger" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

export default SettingAction;
